import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "fact__label" };
const _hoisted_2 = ["title"];
const _hoisted_3 = ["title"];
const _hoisted_4 = ["title"];
const _hoisted_5 = ["title"];
export default /*@__PURE__*/ _defineComponent({
    __name: 'Fact',
    props: {
        label: {},
        value: {},
        variant: {},
        dataType: {}
    },
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("span", {
                class: _normalizeClass(["fact", 'fact--' + (__props.variant ?? 'default')])
            }, [
                _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.$te(__props.label) ? _ctx.$t(__props.label) : __props.label), 1),
                _cache[0] || (_cache[0] = _createTextVNode()),
                (__props.value && __props.dataType === 'date')
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        class: "fact__value",
                        title: _ctx.$date(__props.value),
                        tabindex: "10000"
                    }, _toDisplayString(_ctx.$date(__props.value)), 9, _hoisted_2))
                    : (__props.value && __props.dataType === 'datetime')
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 1,
                            class: "fact__value",
                            title: _ctx.$dateTimeTz(__props.value),
                            tabindex: "10000"
                        }, _toDisplayString(_ctx.$dateTime(__props.value)), 9, _hoisted_3))
                        : (__props.value && __props.dataType === 'datetime_seconds')
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 2,
                                class: "fact__value",
                                title: _ctx.$dateTimeSecTz(__props.value),
                                tabindex: "10000"
                            }, _toDisplayString(_ctx.$dateTimeSec(__props.value)), 9, _hoisted_4))
                            : (_openBlock(), _createElementBlock("span", {
                                key: 3,
                                class: "fact__value",
                                title: __props.value,
                                tabindex: "10000"
                            }, [
                                _renderSlot(_ctx.$slots, "value", {}, () => [
                                    _createTextVNode(_toDisplayString(__props.value), 1)
                                ])
                            ], 8, _hoisted_5))
            ], 2));
        };
    }
});
